// @flow
import { FormattedMessage } from 'react-intl';
import { getDeskSupportLink } from '../../utils/urls';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styles from './SearchError.module.scss';

type Props = $ReadOnly<{||}>;

const SearchError = () => {
    return (
        <div className={styles['error-container']}>
            <div>
                <FormattedMessage id="search_error_1" />
            </div>
            <div>
                <FormattedMessage id="search_error_2" />
                <Link to={getDeskSupportLink()} target="_blank" rel="noopener">
                    <FormattedMessage id="search_error_contact_support" />
                </Link>
                <FormattedMessage id="search_error_3" />
            </div>
        </div>
    );
};

export default React.memo<Props>(SearchError);
